"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UINT256_MAX = void 0;

var _Currencies = _interopRequireDefault(require("./Currencies"));

var _LaminarContract = _interopRequireDefault(require("./LaminarContract"));

var _Margin = _interopRequireDefault(require("./Margin"));

var _Synthetic = _interopRequireDefault(require("./Synthetic"));

const UINT256_MAX = '115792089237316195423570985008687907853269984665640564039457584007913129639935';
exports.UINT256_MAX = UINT256_MAX;

class EthereumApi extends _LaminarContract.default {
  constructor(options) {
    super(options);
    this.chainType = 'ethereum';
    this.gas = void 0;
    this.margin = void 0;
    this.currencies = void 0;
    this.synthetic = void 0;

    this.extrinsicHelper = (extrinsic, signOption, {
      action
    } = {}) => {
      const actionStatus = {
        account: signOption.from,
        action
      };

      if (this.gas) {
        signOption.gas = this.gas;
      }

      return extrinsic.send(signOption).then(result => {
        actionStatus.data = result;
        actionStatus.status = 'success';
        return actionStatus;
      }).catch(error => {
        actionStatus.data = error;
        actionStatus.status = 'error';
        actionStatus.message = error && error.message ? error.message : '';
        return Promise.reject(actionStatus);
      });
    };

    this.isReady = async () => {
      console.log('EthereumApi isReady');
    };

    this.gas = options.gas;
    this.margin = new _Margin.default(this);
    this.currencies = new _Currencies.default(this);
    this.synthetic = new _Synthetic.default(this);
  }

}

var _default = EthereumApi;
exports.default = _default;